export default {
  // Common
  app: {
    name: 'Coloursense',
    tagline: 'Descubre Tus Colores Perfectos',
  },
  common: {
    back: 'Atrás',
    cancel: 'Cancelar',
    save: 'Guardar',
    share: 'Compartir',
    create: 'Crear',
    delete: 'Eliminar',
    edit: 'Editar',
    loading: 'Cargando...',
    error: 'Ocurrió un error',
    success: '¡Éxito!',
    tryAgain: 'Intentar de nuevo',
    reset: 'Reiniciar',
  },
  accessibility: {
    title: 'Configuración de Accesibilidad',
    visualTitle: 'Configuración Visual',
    audioTitle: 'Configuración de Audio',
    colorBlindMode: 'Modo Daltónico',
    colorBlindModeDesc:
      'Ajustar colores para que sean más distinguibles para usuarios daltónicos',
    colorBlindType: 'Tipo de Daltonismo',
    protanopia: 'Protanopia (Ciego al Rojo)',
    deuteranopia: 'Deuteranopia (Ciego al Verde)',
    tritanopia: 'Tritanopia (Ciego al Azul)',
    achromatopsia: 'Acromatopsia (Sin Color)',
    highContrast: 'Alto Contraste',
    highContrastDesc: 'Aumentar el contraste entre texto y fondo',
    largeText: 'Texto Grande',
    largeTextDesc: 'Aumentar el tamaño del texto en toda la aplicación',
    voiceGuidance: 'Guía por Voz',
    voiceGuidanceDesc:
      'Habilitar retroalimentación hablada para navegación y análisis de color',
    showColorNames: 'Mostrar Nombres de Colores',
    showColorNamesDesc:
      'Siempre mostrar nombres de colores junto a las muestras de color',
    resetSettings: 'Reiniciar Configuración de Accesibilidad',
    resetTitle: 'Reiniciar Configuración',
    resetConfirm:
      '¿Estás seguro de que quieres reiniciar toda la configuración de accesibilidad a los valores predeterminados?',
  },

  // Auth
  auth: {
    login: 'Iniciar Sesión',
    register: 'Registrarse',
    email: 'Correo Electrónico',
    password: 'Contraseña',
    forgotPassword: '¿Olvidaste tu contraseña?',
    noAccount: '¿No tienes una cuenta?',
    hasAccount: '¿Ya tienes una cuenta?',
    logout: 'Cerrar Sesión',
  },

  // Home Screen
  home: {
    features: 'Características',
    startAnalysis: 'Iniciar Análisis de Color',
    comingSoon: 'Próximamente',
  },

  // Color Analysis
  colorAnalysis: {
    title: 'Análisis de Color',
    upload: 'Subir Foto',
    takePhoto: 'Tomar Foto',
    analyzing: 'Analizando tus colores...',
    results: 'Resultados del Análisis',
    yourPalette: 'Tu Paleta de Colores',
  },

  // Virtual Drape Test
  drapeTest: {
    title: 'Prueba Virtual de Colores',
    subtitle: 'Prueba Colores Junto a Tu Rostro',
    uploadSelfie:
      'Sube una selfie y compara cómo se ven diferentes colores junto a tu rostro',
    chooseGallery: 'Elegir de la Galería',
    takeSelfie: 'Tomar Selfie',
    changeImage: 'Cambiar Imagen',
    colorPalettes: 'Paletas de Colores',
    tapColor: 'Toca un color para ver cómo se ve junto a tu rostro',
    analysis: 'Análisis de Color',
    howWorks: 'Cómo funciona este color para ti:',
    selectColor:
      'Selecciona un color arriba para ver comentarios personalizados',
    createCard: 'Crear Tarjeta para Compartir',
  },

  // Smart Wardrobe
  wardrobe: {
    title: 'Armario Inteligente',
    yourPalette: 'Tu Paleta de Colores',
    yourItems: 'Tus Prendas de Ropa',
    addItem: '+ Añadir Prenda',
    addNew: 'Añadir Nueva Prenda',
    uploadPhoto: 'Subir foto de la prenda',
    itemName: 'Nombre del Artículo',
    tags: 'Etiquetas (separadas por comas)',
    addToWardrobe: 'Añadir al Armario',
    paletteMatch: 'Coincidencia con Paleta:',
  },

  // Wear This Today
  outfits: {
    title: 'Qué Usar Hoy',
    weather: 'Clima de Hoy',
    humidity: 'Humedad',
    wind: 'Viento',
    recommended: 'Outfit Recomendado para Hoy',
    generating: 'Generando outfit perfecto...',
    generateAnother: 'Generar Otro Outfit',
    whyChosen: 'Por Qué Elegimos Esto',
  },

  // Premium Features
  premium: {
    title: 'Desbloquea Funciones Premium',
    subtitle:
      'Actualiza a Coloursense Premium para acceso completo a todas las funciones',
    smartWardrobe: 'Armario Inteligente',
    wardrobeDesc:
      'Etiqueta tu ropa y descubre qué se ajusta a tu paleta de colores',
    wearToday: 'Qué Usar Hoy',
    wearTodayDesc:
      'Obtén sugerencias de outfits basadas en el clima y tus colores',
    unlimited: 'Análisis Ilimitado',
    unlimitedDesc:
      'Crea perfiles de color ilimitados y guarda tu historial de análisis',
    noAds: 'Sin Anuncios',
    noAdsDesc: 'Disfruta de una experiencia sin anuncios en toda la aplicación',
    monthly: 'Mensual',
    yearly: 'Anual',
    save: 'Ahorra 30%',
    perMonth: 'por mes',
    perYear: 'por año',
    upgradeButton: 'Actualizar a Premium',
    processing: 'Procesando...',
    restore: 'Restaurar Compras',
    terms:
      'El pago se cargará a tu cuenta de Apple ID al confirmar la compra. La suscripción se renueva automáticamente a menos que se cancele al menos 24 horas antes del final del período actual. Tu cuenta será cargada por la renovación dentro de las 24 horas previas al final del período actual. Puedes administrar y cancelar tus suscripciones yendo a la configuración de tu cuenta en App Store después de la compra.',
  },

  // Subscription Context
  subscription: {
    freePlan: 'Plan Gratuito',
    premiumPlan: 'Plan Premium',
    upgradeSuccess: '¡Actualizado a Premium con éxito!',
    upgradeError: 'Error al actualizar a Premium',
    restoreSuccess: '¡Compras restauradas con éxito!',
    restoreError: 'Error al restaurar compras',
    premiumRequired: 'Premium Requerido',
    premiumFeature: 'Esta es una función premium',
    upgradeToAccess: 'Actualiza a Premium para acceder a esta función',
    goToPremium: 'Ir a Premium',
    continueFree: 'Continuar con Gratuito',
  },

  // Shareable Cards
  shareableCard: {
    title: 'Tu Tarjeta de Color',
    cannotCreate: 'No se Puede Crear la Tarjeta',
    selectImageColor: 'Por favor selecciona una imagen y un color primero.',
    saved: '¡Tarjeta guardada en tus fotos!',
    shareTitle: 'Comparte Tu Tarjeta de Color',
    notAvailable: 'Compartir no disponible',
    notAvailableDesc: 'Compartir no está disponible en tu dispositivo',
    error: 'Error al compartir tu tarjeta de color.',
    myAnalysis: 'Mi Análisis de Color',
    createdWith: 'Creado con Coloursense',
  },

  // Lighting Conditions
  lighting: {
    title: 'Condiciones de Iluminación',
    standard: {
      name: 'Estándar',
      description:
        'Iluminación interior equilibrada, adecuada para la mayoría de los ambientes',
    },
    tropical: {
      name: 'Tropical',
      description: 'Luz solar brillante y cálida con alta intensidad',
    },
    nordic: {
      name: 'Nórdica',
      description:
        'Luz natural fría con tinte azulado común en regiones del norte',
    },
    office: {
      name: 'Oficina',
      description: 'Iluminación fluorescente típica en entornos de oficina',
    },
    evening: {
      name: 'Nocturna',
      description:
        'Iluminación cálida y dorada durante el atardecer o con lámparas interiores',
    },
    selectLighting: 'Seleccionar Condición de Iluminación',
    adjustPalette: 'Ajustar paleta para diferentes iluminaciones',
  },
};
